import { useEffect, useState } from "react";
import FilterMenu from "./FilterMenu";
import state from "../../../../src/config/valtio/store";
import DynamicTable from "../../../components/DynamicTable";
import { message } from "antd";
import API from "../../../services/api-request";
import dayjs from "dayjs";
import { useSearchParams } from "react-router-dom";

const HistoryStatusCard = ({ id }) => {
  const [dataHistory, setDataHistory] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();

  const getDataHistory = async (
    strDate = searchParams.get("strDate"),
    endDate = searchParams.get("endDate"),
    card_id = searchParams.get("id")
  ) => {
    state.LOADING = true;

    await API.Get(
      `history?card_id=${card_id}&start_date=${strDate}&end_date=${endDate}`
    )
      .then((result) => {
        setDataHistory(result.data.histories);
      })
      .catch((err) => {
        setDataHistory([]);
        if (id) {
          message.info("Failed Fetch History Data!");
        }
      });

    state.LOADING = false;
  };

  useEffect(() => {
    getDataHistory();

    state.LOADING = false;
    // eslint-disable-next-line
  }, [id]);

  const handleQuery = (values) => {
    getDataHistory(values.strDate, values.endDate);
  };

  const column = [
    {
      title: "Event Date",
      dataIndex: "created_at",
      key: "created_at",
      sorter: (a, b) => a.created_at - b.created_at,
      render: (created_at) => {
        if (created_at === null || created_at === "") {
          return "-";
        } else {
          return dayjs(created_at).format("YYYY-MM-DD HH:mm:ss");
        }
      },
    },
    {
      title: "Operation",
      dataIndex: "operation",
      key: "operation",
      sorter: (a, b) => a.operation - b.operation,
      render: (operation) => {
        if (operation === null || operation === "") {
          return "-";
        } else {
          return operation;
        }
      },
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      sorter: (a, b) => a.description - b.description,
      render: (description) => {
        if (description === null || description === "") {
          return "-";
        } else {
          return description;
        }
      },
    },
    {
      title: "Source Type",
      dataIndex: "user_name",
      key: "user_name",
      sorter: (a, b) => a.user_name - b.user_name,
      render: (user_name) => {
        if (user_name === null || user_name === "") {
          return "-";
        } else {
          return user_name;
        }
      },
    },
    {
      title: "Source Name",
      dataIndex: "user_name",
      key: "user_name",
      sorter: (a, b) => a.user_name - b.user_name,
      render: (user_name) => {
        if (user_name === null || user_name === "") {
          return "-";
        } else {
          return user_name;
        }
      },
    },
  ];

  return (
    <>
      {/* Filter Menu */}
      <FilterMenu onQueryDate={handleQuery} />

      {/* List History Table */}
      <DynamicTable data={dataHistory} columns={column} />
    </>
  );
};

export default HistoryStatusCard;
